/*
Common core of algolia functionality used by
both the use-algolia Hook, and the Next JS
GetServerSideProps for server rendering
*/
import algoliasearch from 'algoliasearch';
import { getNowInCentreInTimeFormat } from '../../helpers/date-helpers';
import { Segment } from './types';
import querySegments from './query-segments';

const getDefaultNationalTimezone = country => {
  if (country === 'New Zealand') {
    return 'Pacific/Auckland';
  } else {
    return 'Australia/Sydney';
  }
};

export const makeOffsetlessTimeGetters = (country, centre) => ({
  getOffsetlessTimeInDefaultTz: getNowInCentreInTimeFormat(getDefaultNationalTimezone(country)),
  getOffsetlessTimeInCentre: centre && getNowInCentreInTimeFormat(centre.timeZone)
});
export function makeClients(algoliaApiKeys) {
  const {
    contentApplicationId,
    contentApiKey,
    marketplaceApplicationId,
    marketplaceApiKey
  } = algoliaApiKeys;

  if (!contentApplicationId || !contentApiKey || !marketplaceApplicationId || !marketplaceApiKey) {
    return undefined;
  }

  return {
    content: algoliasearch(contentApplicationId, contentApiKey),
    marketplace: algoliasearch(marketplaceApplicationId, marketplaceApiKey)
  };
}
const segments = Object.values(Segment);
export const doQueryAlgolia = ({
  query,
  clients,
  context
}) => clients ? querySegments(query, clients, context, segments) : Promise.reject(new Error('Algolia clients not initalised'));